import * as R from "ramda"
import head from "lodash/head"
import commonApiAuthRequest from "../apiAuthRequest"
import { SAP_LOADER_SERVICE_URL, PASSPORT_REFERENCE_URL } from "./constants"

const techCardFetch = sapIssueId =>
  commonApiAuthRequest({
    url: `${SAP_LOADER_SERVICE_URL}/get_issues`,
    method: `post`,
    data: {
      where: {
        issueNumber: sapIssueId,
      },
    },
  })

const currentTechCardFetch = taskCard =>
  commonApiAuthRequest({
    url: `${PASSPORT_REFERENCE_URL}/ds/data/object/maintask_cardv1DS`,
    method: `post`,
    data: {
      filter: {
        type: `EQUAL`,
        ignoreCase: true,
        left: {
          field: `external_code`,
          type: `field`,
        },
        right: {
          dataType: { type: `TEXT` },
          type: `constant`,
          value: taskCard,
        },
      },
    },
  })

/**
 * makes request to get techCard from sap and reference by equipment's code
 *
 * @param {string} sapIssueId
 * @return {Array.<Object>} response - techCard
 */
export const getTechCard = async sapIssueId => {
  if (!sapIssueId) {
    return undefined
  }

  const { data: result } = await techCardFetch(sapIssueId)

  const { taskCardGroup, taskCardNumber, taskCardType } =
    R.mergeAll(result) || {}

  if (!taskCardGroup && !taskCardNumber && !taskCardType) {
    return undefined
  }

  const taskCard = `${taskCardType}-${taskCardGroup}-${taskCardNumber}`

  const { data: techCards } = await currentTechCardFetch(taskCard)

  return head(techCards)
}
